module.exports = __webpack_public_path__ + "img/sumit.13655780.png";